
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const ServicesContent = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Externe Dienste und Technologien</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6 text-sm text-joerg-600">
        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Hosting und Infrastruktur</h4>
          <p className="leading-relaxed mb-3">
            Diese Website wird über die Infrastruktur von Lovable.dev (Lovable Technologies Ltd.) bereitgestellt. Der Anbieter verarbeitet technisch notwendige Verbindungsdaten (IP-Adresse, Zeitpunkt des Zugriffs, übertragene Datenmenge) im Rahmen der Bereitstellung der Website.
          </p>
          <p className="leading-relaxed mb-3">
            Die Datenbank-Infrastruktur wird von Supabase Inc., 970 Toa Payoh North #07-04, Singapore 318992, bereitgestellt. Supabase fungiert als Auftragsverarbeiter gemäß Art. 28 DSGVO und agiert als sicherer Gateway mit Row-Level-Security (RLS) und strengen Zugriffsregeln für datenminimalen Transit. Es werden ausschließlich die für den jeweiligen Vorgang erforderlichen Daten verarbeitet – nicht benötigte Daten werden durch die RLS-Richtlinien bereits auf Datenbankebene blockiert.
          </p>
          <p className="leading-relaxed">
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer zuverlässigen Bereitstellung der Website).
          </p>
        </div>

        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Cloudflare CDN (Content Delivery Network)</h4>
          <p className="leading-relaxed mb-3">
            Diese Website nutzt Cloudflare als Content Delivery Network (CDN) und zur Verbesserung der Sicherheit und Performance. Anbieter ist die Cloudflare Inc., 101 Townsend St., San Francisco, CA 94107, USA.
          </p>
          
          <p className="leading-relaxed mb-3">
            <strong>Art der verarbeiteten Daten:</strong><br />
            Bei jedem Aufruf dieser Website werden durch Cloudflare automatisch Informationen erfasst: IP-Adresse, Browsertyp und -version, verwendetes Betriebssystem, Referrer-URL, Hostname des zugreifenden Rechners, Uhrzeit der Serveranfrage, übertragene Datenmenge.
          </p>
          
          <p className="leading-relaxed mb-3">
            <strong>Zweck der Datenverarbeitung:</strong><br />
            Cloudflare wird eingesetzt zur Beschleunigung der Auslieferung unserer Website (Caching), zur Abwehr von DDoS-Angriffen, zur Filterung von schadhaftem Traffic und zur Gewährleistung der Sicherheit und Integrität unserer Website.
          </p>
          
          <p className="leading-relaxed mb-3">
            <strong>Rechtsgrundlage:</strong><br />
            Die Nutzung von Cloudflare erfolgt auf Grundlage unseres berechtigten Interesses an einer möglichst fehlerfreien, sicheren und schnellen Bereitstellung unseres Webangebots (Art. 6 Abs. 1 lit. f DSGVO).
          </p>
          
          <p className="leading-relaxed mb-3">
            <strong>Datenübermittlung in die USA:</strong><br />
            Cloudflare ist durch das EU-US Data Privacy Framework zertifiziert. Die Datenübermittlung in die USA erfolgt auf Grundlage von Standardvertragsklauseln der EU-Kommission (Art. 46 Abs. 2 lit. c DSGVO).
          </p>
          
          <p className="leading-relaxed mb-3">
            <strong>Speicherdauer:</strong><br />
            Die gespeicherten Logfiles werden nach maximal 30 Tagen gelöscht.
          </p>
          
          <p className="leading-relaxed mb-3">
            <strong>Widerspruchsrecht:</strong><br />
            Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Sie betreffender personenbezogener Daten, die aufgrund von Art. 6 Abs. 1 lit. f DSGVO erfolgt, Widerspruch einzulegen.
          </p>
          
          <div className="bg-joerg-50 p-4 rounded-lg mt-2 mb-3">
            <p className="text-sm">
              <strong>Bitte beachten Sie:</strong> Ein Widerspruch gegen die Nutzung von Cloudflare kann dazu führen, dass unsere Website nicht oder nur eingeschränkt funktioniert, da Cloudflare für die technische Bereitstellung unserer Website erforderlich ist.
            </p>
            <p className="text-sm mt-2">
              Widerspruch per E-Mail an: <a href="mailto:info@joerg-hoermann.de" className="text-primary hover:underline">info@joerg-hoermann.de</a>
            </p>
          </div>
          
          <p className="leading-relaxed">
            Weitere Informationen: <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Cloudflare Datenschutzerklärung</a>
          </p>
        </div>

        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Schriftarten (lokal gehostet)</h4>
          <p className="leading-relaxed">
            Diese Website und alle zugehörigen Subdomains verwenden ausschließlich lokal gehostete Schriftarten. Die Schriftdateien werden direkt von unserem Server ausgeliefert. Es wird <strong>keine Verbindung zu Google-Servern</strong> (fonts.googleapis.com oder fonts.gstatic.com) oder anderen externen Font-Diensten hergestellt. Es erfolgt somit keine Übermittlung Ihrer IP-Adresse oder anderer Daten an Dritte im Zusammenhang mit der Schriftarteneinbindung.
          </p>
        </div>

        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Cookies</h4>
          <p className="leading-relaxed">
            Diese Website verwendet ausschließlich technisch notwendige Cookies, die für den Betrieb der Website erforderlich sind (z.&nbsp;B. Session-Cookies für das Kontaktformular). Es werden <strong>keine Tracking-, Werbe- oder Analyse-Cookies</strong> gesetzt. Eine Einwilligung über ein Cookie-Banner ist daher nicht erforderlich.
          </p>
        </div>

        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Spam-Schutz im Kontaktformular</h4>
          <p className="leading-relaxed mb-3">
            Zum Schutz vor automatisiertem Missbrauch (Spam) nutzt das Kontaktformular dieser Website ausschließlich <strong>serverseitige, datenschutzfreundliche Schutzmechanismen</strong>. Es werden <strong>keine externen Dienste</strong> (wie z.&nbsp;B. Google reCAPTCHA) eingesetzt.
          </p>
          <p className="leading-relaxed mb-3">
            <strong>Eingesetzte Maßnahmen:</strong>
          </p>
          <ul className="list-disc list-inside space-y-1 mb-3">
            <li>Technische Plausibilitätsprüfungen (z.&nbsp;B. Zeitprüfung der Formularausfüllung)</li>
            <li>Unsichtbare Formularfelder zur Bot-Erkennung (sog. Honeypot-Methode)</li>
            <li>Serverseitige Anfragebegrenzung (Rate-Limiting) pro IP-Adresse</li>
          </ul>
          <p className="leading-relaxed mb-3">
            <strong>Art der verarbeiteten Daten:</strong><br />
            Für den Spam-Schutz werden ausschließlich technische Daten verarbeitet, die ohnehin bei der Nutzung des Kontaktformulars anfallen: anonymisierte IP-Adresse, Zeitstempel des Formularaufrufs und der Absendung. Es werden <strong>keine Daten an Drittanbieter übermittelt</strong>.
          </p>
          <p className="leading-relaxed mb-3">
            <strong>Rechtsgrundlage:</strong><br />
            Die Verarbeitung erfolgt auf Grundlage unseres berechtigten Interesses am Schutz unseres Kontaktformulars vor missbräuchlichen automatisierten Zugriffen (Art. 6 Abs. 1 lit. f DSGVO). Die eingesetzten Maßnahmen sind datenminimal und erfordern keine Einbindung externer Dienste.
          </p>
          <p className="leading-relaxed">
            <strong>Widerspruchsrecht:</strong><br />
            Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Widerspruch einzulegen. Widerspruch per E-Mail an: <a href="mailto:info@joerg-hoermann.de" className="text-primary hover:underline">info@joerg-hoermann.de</a>
          </p>
        </div>

        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Kontaktformular</h4>
          <p className="leading-relaxed mb-3">
            Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
          </p>
          <p className="leading-relaxed">
            <strong>Rechtsgrundlage:</strong> Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Ihre Anfrage wird nach Erledigung gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
          </p>
        </div>

        <div>
          <h4 className="font-medium text-joerg-700 mb-2">E-Mail-Versand (Resend)</h4>
          <p className="leading-relaxed mb-3">
            Für den Versand von E-Mails im Zusammenhang mit dem Kontaktformular (z.&nbsp;B. Eingangsbestätigungen) nutzen wir den Dienst Resend. Anbieter ist die Resend Inc., 2261 Market Street #4059, San Francisco, CA 94114, USA.
          </p>
          
          <p className="leading-relaxed mb-3">
            <strong>Art der verarbeiteten Daten:</strong><br />
            Bei der Nutzung von Resend werden folgende Daten verarbeitet: E-Mail-Adresse des Empfängers, Name (soweit im Kontaktformular angegeben), Inhalt der E-Mail-Nachricht, Zeitpunkt des Versands sowie technische Zustellinformationen (z.&nbsp;B. Zustellstatus).
          </p>
          
          <p className="leading-relaxed mb-3">
            <strong>Zweck der Datenverarbeitung:</strong><br />
            Resend wird ausschließlich für den technischen Versand von E-Mails im Rahmen der Kontaktformular-Bearbeitung eingesetzt. Es findet <strong>kein E-Mail-Tracking</strong> (Öffnungsraten, Klickverhalten) statt.
          </p>
          
          <p className="leading-relaxed mb-3">
            <strong>Rechtsgrundlage:</strong><br />
            Die Nutzung von Resend erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung bzw. vorvertragliche Maßnahmen) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der zuverlässigen Zustellung von E-Mails). Resend fungiert als Auftragsverarbeiter gemäß Art. 28 DSGVO.
          </p>
          
          <p className="leading-relaxed mb-3">
            <strong>Datenübermittlung in die USA:</strong><br />
            Resend hat seinen Sitz in den USA. Die Datenübermittlung erfolgt auf Grundlage von Standardvertragsklauseln der EU-Kommission (Art. 46 Abs. 2 lit. c DSGVO), die ein angemessenes Datenschutzniveau gewährleisten.
          </p>
          
          <p className="leading-relaxed mb-3">
            <strong>Speicherdauer:</strong><br />
            E-Mail-Versanddaten werden bei Resend für maximal 30 Tage gespeichert und anschließend automatisch gelöscht.
          </p>
          
          <p className="leading-relaxed mb-3">
            <strong>Widerspruchsrecht:</strong><br />
            Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Ihrer personenbezogenen Daten Widerspruch einzulegen. Alternativ können Sie uns direkt per Telefon kontaktieren, um den E-Mail-Versand zu umgehen.
          </p>
          
          <div className="bg-joerg-50 p-4 rounded-lg mt-2 mb-3">
            <p className="text-sm">
              Widerspruch per E-Mail an: <a href="mailto:info@joerg-hoermann.de" className="text-primary hover:underline">info@joerg-hoermann.de</a> oder telefonisch unter 09171-9892118.
            </p>
          </div>
          
          <p className="leading-relaxed">
            Weitere Informationen: <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Resend Datenschutzerklärung</a>
          </p>
        </div>

        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Terminbuchung (Zeeg)</h4>
          <p className="leading-relaxed mb-3">
            Für die Online-Terminbuchung nutzen wir den Dienst Zeeg (Zeeg GmbH, Deutschland). Wenn Sie einen Termin buchen, werden Ihre eingegebenen Daten (Name, E-Mail-Adresse, gewünschter Termin) an Zeeg übermittelt.
          </p>
          <p className="leading-relaxed">
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung). Weitere Informationen: <a href="https://zeeg.me/privacy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Zeeg Datenschutzerklärung</a>
          </p>
        </div>

        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Buchempfehlungen</h4>
          <p className="leading-relaxed">
            Diese Website enthält Verlinkungen zu einer lokalen Buchhandlung. Diese Links dienen ausschließlich als Serviceempfehlung. Es bestehen <strong>keine Affiliate- oder Provisionsvereinbarungen</strong>. Beim Klick auf diese Links verlassen Sie unsere Website – es gelten dann die Datenschutzbestimmungen des jeweiligen Anbieters.
          </p>
        </div>
        
        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Social Media Präsenzen</h4>
          <p className="leading-relaxed">
            Wir unterhalten Online-Präsenzen innerhalb sozialer Netzwerke und Plattformen, um mit den dort aktiven Kunden, Interessenten und Nutzern kommunizieren und sie dort über unsere Leistungen informieren zu können.
          </p>
          
          <p className="mt-2 leading-relaxed">
            <strong>LinkedIn</strong><br />
            Wir nutzen LinkedIn für unsere Online-Präsenz. Anbieter ist die LinkedIn Ireland Unlimited Company, Wilton Place, Dublin 2, Irland. Weitere Informationen: <a href="https://www.linkedin.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">LinkedIn Datenschutzrichtlinie</a>
          </p>
          
          <p className="mt-2 leading-relaxed">
            <strong>Instagram</strong><br />
            Anbieter ist die Meta Platforms Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland. Weitere Informationen: <a href="https://help.instagram.com/519522125107875" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Instagram Datenschutzrichtlinie</a>
          </p>
          
          <p className="mt-2 leading-relaxed">
            <strong>YouTube</strong><br />
            Anbieter ist die Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Weitere Informationen: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Google Datenschutzrichtlinie</a>
          </p>
          
          <p className="mt-2 leading-relaxed">
            <strong>BlueSky</strong><br />
            Anbieter ist die Bluesky PBC. Weitere Informationen: <a href="https://bsky.social/about/policies/privacy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">BlueSky Datenschutzrichtlinie</a>
          </p>
          
          <p className="mt-2 leading-relaxed">
            Wir weisen darauf hin, dass beim Besuch der jeweiligen Plattformen die Geschäftsbedingungen und die Datenverarbeitungsrichtlinien der jeweiligen Betreiber gelten. Wir haben keinen Einfluss auf die Erhebung und Verarbeitung von personenbezogenen Daten durch die Betreiber dieser Plattformen.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default ServicesContent;
